import { render, staticRenderFns } from "./importToCreateTransWarehouse.vue?vue&type=template&id=bf3dd4ca&scoped=true&"
import script from "./importToCreateTransWarehouse.vue?vue&type=script&lang=js&"
export * from "./importToCreateTransWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./importToCreateTransWarehouse.vue?vue&type=style&index=0&id=bf3dd4ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3dd4ca",
  null
  
)

component.options.__file = "importToCreateTransWarehouse.vue"
export default component.exports